$(function() {
  if ($('body.pages.show').length < 1) return

  // reward-modal
  const $rewardModal = $('.js-reward-modal')
  $('.js-reward-detail-btn').on('click', function() {
    $rewardModal.modal('show')
  })
})
